export function createEndurance() { return { stamina: 100, sprinting: false, sprintReadyAt: 0, dodgeReadyAt: 0, regenAt: 0 }; }
export function requestSprint(s, active, now, alive = true) {
  if (!active) {
    if (s.sprinting) { s.sprinting = false; s.sprintReadyAt = now + 1500; s.regenAt = now + 750; }
    return true;
  }
  if (!alive || now < s.sprintReadyAt || s.stamina < 12) return false;
  s.sprinting = true; return true;
}
export function requestDodge(s, now, alive = true) {
  if (!alive || now < s.dodgeReadyAt || s.stamina < 18) return false;
  requestSprint(s, false, now); s.stamina -= 18; s.dodgeReadyAt = now + 900; s.regenAt = now + 1000; return true;
}
export function stepEndurance(s, now, seconds, alive) {
  const dt = Math.max(0, Math.min(.5, seconds));
  if (!alive) { requestSprint(s, false, now); return; }
  if (s.sprinting) {
    s.stamina = Math.max(0, s.stamina - 25 * dt);
    if (!s.stamina) { requestSprint(s, false, now); s.sprintReadyAt = now + 2000; }
  } else if (now >= s.regenAt) s.stamina = Math.min(100, s.stamina + 18 * dt);
}
